/*
  gehna-mobile-fix.js

  1. Keeps --header-bottom-position accurate.
  2. Locks body scroll when menu drawer is open.
  3. Locks BOTH html AND body scroll when cart drawer is open,
     while keeping cart-drawer-items itself scrollable.
  4. Patches HeaderDrawer.openMenuDrawer.
*/
(function () {
  'use strict';

  /* --- 1. Header position --- */
  function getHeaderBottom() {
    var header = document.querySelector('.section-header');
    if (!header) return 0;
    return Math.round(header.getBoundingClientRect().bottom);
  }

  function setHeaderPos(bottom) {
    bottom = (bottom !== undefined) ? bottom : getHeaderBottom();
    document.documentElement.style.setProperty('--header-bottom-position', bottom + 'px');
    document.documentElement.style.setProperty('--viewport-height', window.innerHeight + 'px');
  }

  setHeaderPos();
  /* rAF-throttle scroll/resize so getBoundingClientRect() runs at most once per frame.
     This file is the single owner of the header-position update (the duplicate
     listeners in gfy-coupons.js were removed to avoid a double forced layout). */
  var _hpTicking = false;
  function _onHeaderReflow() {
    if (_hpTicking) return;
    _hpTicking = true;
    requestAnimationFrame(function () { setHeaderPos(); _hpTicking = false; });
  }
  window.addEventListener('scroll', _onHeaderReflow, { passive: true });
  window.addEventListener('resize', _onHeaderReflow, { passive: true });

  /* --- 2. Menu drawer scroll lock --- */
  function attachMenuObserver() {
    var details = document.querySelector('#Details-menu-drawer-container');
    if (!details) return;
    new MutationObserver(function () {
      document.body.classList.toggle('gfy-drawer-open', details.hasAttribute('open'));
    }).observe(details, { attributes: true, attributeFilter: ['open'] });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && !details.hasAttribute('open')) {
        document.body.classList.remove('gfy-drawer-open');
      }
    });
  }

  /* --- 3. Cart drawer scroll lock --- */
  /*
    Problem: page scroll is on <html> (because body is display:grid).
    overflow:hidden on body alone does NOT stop scroll on iOS/Android
    when the scroll container is <html>.

    Fix: lock BOTH <html> and <body>. Store scrollY, apply
    position:fixed to body with top:-scrollY (classic iOS lock).
    Allow touchmove only inside cart-drawer-items.

    On cart close, restore body position and scroll to saved position.
  */
  var _cartScrollY = 0;

  function lockCartScroll() {
    _cartScrollY = window.pageYOffset;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + _cartScrollY + 'px';
    document.body.style.width = '100%';
    document.documentElement.style.overflow = 'hidden';
  }

  function unlockCartScroll() {
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.documentElement.style.overflow = '';
    window.scrollTo(0, _cartScrollY);
  }

  function attachCartObserver() {
    /* Watch for the .active class on .drawer which Dawn adds on open */
    var drawerEl = document.querySelector('.drawer');
    if (!drawerEl) return;

    var wasActive = false;
    new MutationObserver(function () {
      var isActive = drawerEl.classList.contains('active');
      if (isActive && !wasActive) {
        lockCartScroll();
        wasActive = true;
      } else if (!isActive && wasActive) {
        unlockCartScroll();
        wasActive = false;
      }
    }).observe(drawerEl, { attributes: true, attributeFilter: ['class'] });

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        unlockCartScroll();
        wasActive = false;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      attachMenuObserver();
      attachCartObserver();
    });
  } else {
    attachMenuObserver();
    attachCartObserver();
  }

  /* --- 4. Patch HeaderDrawer --- */
  function patchHeaderDrawer() {
    var HD = customElements.get('header-drawer');
    if (!HD) return false;
    var proto = HD.prototype;
    if (proto.__gfyPatched) return true;
    proto.__gfyPatched = true;
    var _origOpen = proto.openMenuDrawer;
    proto.openMenuDrawer = function (summaryElement) {
      var self = this;
      if (window.scrollY > 0) {
        window.scrollTo({ top: 0, behavior: 'instant' });
      }
      setHeaderPos(getHeaderBottom());
      _origOpen.call(self, summaryElement);
    };
    return true;
  }

  if (!patchHeaderDrawer()) {
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      if (patchHeaderDrawer() || attempts > 40) clearInterval(interval);
    }, 50);
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) setHeaderPos();
  });

})();
